module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-italic.e3c56211.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-italic.ttf
// module id = 490
// module chunks = 0